import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	noImageLabel: {
		id: 'custom-sites-extensions.unsplash-search.default-image-picker.no-image',
		defaultMessage: 'No image',
		description: 'Alt label for default unsplash pick with no image',
	},
});
